import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={215}
    height={318}
    viewBox="0 0 215 318"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.12}>
      <rect width={318} height={318} rx={159} fill="#D0FBE8" />
      <path
        d="M152.314 40.4528C156.26 37.4315 161.742 37.4315 165.688 40.4528L188.095 57.6088C190.09 59.1359 192.547 59.9343 195.059 59.8712L223.271 59.1627C228.239 59.0379 232.674 62.26 234.091 67.0238L242.135 94.0742C242.851 96.4821 244.37 98.5723 246.438 99.9974L269.679 116.007C273.772 118.826 275.466 124.04 273.812 128.726L264.42 155.339C263.584 157.708 263.584 160.292 264.42 162.66L273.812 189.273C275.466 193.96 273.772 199.173 269.679 201.992L246.438 218.002C244.37 219.427 242.851 221.517 242.135 223.925L234.091 250.976C232.674 255.739 228.239 258.961 223.271 258.837L195.059 258.128C192.547 258.065 190.09 258.863 188.095 260.391L165.688 277.547C161.742 280.568 156.26 280.568 152.314 277.547L129.906 260.391C127.911 258.863 125.454 258.065 122.943 258.128L94.7304 258.837C89.7621 258.961 85.3272 255.739 83.9106 250.976L75.8664 223.925C75.1504 221.517 73.6317 219.427 71.5629 218.002L48.3223 201.992C44.2294 199.173 42.5355 193.96 44.1895 189.273L53.5814 162.66C54.4174 160.292 54.4174 157.708 53.5814 155.339L44.1894 128.726C42.5355 124.04 44.2294 118.826 48.3223 116.007L71.5629 99.9974C73.6317 98.5723 75.1504 96.4821 75.8664 94.0742L83.9106 67.0238C85.3273 62.26 89.7621 59.0379 94.7305 59.1627L122.943 59.8712C125.454 59.9343 127.911 59.1359 129.906 57.6087L152.314 40.4528Z"
        fill="#00B186"
      />
      <mask
        id="mask0_3795_59421"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={79}
        y={79}
        width={160}
        height={160}
      >
        <rect x={79.5} y={79.5} width={159} height={159} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3795_59421)">
        <path
          d="M142.766 198.751L105.004 160.988L114.445 151.547L142.766 179.869L203.551 119.085L212.991 128.526L142.766 198.751Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
);
export default SVGComponent;
